export default __webpack_public_path__ + "static/media/chat.cfce70ed.svg";